module.exports = __webpack_public_path__ + "static/media/aura_logo.41e791c3.png";